import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_user_task_create } from '@/state/generation/user_task/entity/remote_user_task_create';
import { store } from '@/state/store';
import { set_current_generation } from '@/utils/utils_client_workspace_child_entity_viewers';
import { assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useState } from 'react';

export function HOOK_USER_TASK__create() {
  const dispatch = use_dispatch();
  const navigate = use_navigate_ud();

  const [is_loading, set_is_loading] = useState(false);
  const [component_id, set_component_id] = useState('');

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_USER_TASK);

  const { on_user_uses_component, on_user_uses_shortcut } = use_hint_shortcut(EShortcutType.USER_TASK_CREATE);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (component_id) void notifier.send_action();
  }, [component_id]);

  /*
   * METHODS
   */
  async function create_user_task(is_used_shortcut: boolean) {
    is_used_shortcut ? on_user_uses_shortcut() : on_user_uses_component();

    set_is_loading(true);
    let action_result = await dispatch(remote_user_task_create(current_workspace_user.workspace_id));
    set_is_loading(false);

    if (typeof action_result.payload != 'string') return;

    let user_task_id = action_result.payload;

    assert_string_object_id_not_empty(user_task_id);

    let user_task = store.getState().slice_generation.user_tasks_map.get_or_assert(user_task_id);

    let most_recent_generation = user_task.getMostRecentGeneration();
    await set_current_generation(most_recent_generation._id);

    await navigate(ENUM__page_type.BUILD_PATH_GENERATION(most_recent_generation._id));

    set_component_id(`${ENUM__component_type.PAGE_USER_TASKS_LIST_ITEM}_${user_task_id}`);
  }

  return { is_loading, create_user_task };
}
